"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPAYMENT_STRATEGIES = exports.ERROR_MESSAGES = void 0;
exports.ERROR_MESSAGES = {
    BALANCE_ERROR: 'Balance must be greater than 0',
    INTEREST_RATE_ERROR: 'Interest rate must be greater than 0',
    MIN_PAYMENT_ERROR: 'Minimum payment must be greater than 0',
    MIN_PAYMENT_NOT_ENOUGH: 'Minimum payment is not enough to cover interest',
    PAYMENT_OPTIONS_ERROR: 'Balance, interest, and payment are required',
};
exports.REPAYMENT_STRATEGIES = {
    AVALANCHE: 'avalanche',
    SNOWBALL: 'snowball',
};
